import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "i18next";
import { flagEnabled } from "../utils/flag";

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const languages = [
    { code: "us", name: "English", flag: "/images/us.jpg" },
    { code: "es", name: "Spanish", flag: "/images/spain.jpg" },
    { code: "sk", name: "Slovak", flag: "/images/slovakia.jpg" },
    { code: "it", name: "Italian", flag: "/images/italy.jpg" },
    // { code: 'pt', name: 'Portuguese', flag: '/images/portugual.jpg' },
    // { code: 'pl', name: 'Polish', flag: '/images/Poland.jpg' },
    // { code: 'fr', name: 'French', flag: '/images/French.jpg' },
  ];

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    languages.find((lang) => lang.code === i18n.language) || languages[0]
  );
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("languageCode")) {
      const langCode = sessionStorage.getItem("languageCode");
      changeLanguage(langCode);
      setSelectedLanguage(languages.find((lang) => lang.code === langCode));
    }
  }, []);

  useEffect(() => {
    const currentLang = languages.find((lang) => lang.code === i18n.language);
    if (currentLang) {
      setSelectedLanguage(currentLang);
    }
  }, [i18n.language]);

  const handleChangeLanguage = (code) => {
    const lang = languages.find((l) => l.code === code);
    i18n.changeLanguage(code);
    changeLanguage(code);
    sessionStorage.setItem("languageCode", code);
    setSelectedLanguage(lang);
    setIsDropdownOpen(false);
  };

  return (
    <div className="lang-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="lang-btn"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-language"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 5h7" />
          <path d="M9 3v2c0 4.418 -2.239 8 -5 8" />
          <path d="M5 9c0 2.144 2.952 3.908 6.7 4" />
          <path d="M12 20l4 -9l4 9" />
          <path d="M19.1 18h-6.2" />
        </svg>
        {/* <img
          src={selectedLanguage.flag}
          alt={selectedLanguage.name}
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            marginRight: "0.5rem",
          }}
        />
        &nbsp; */}
        {/* {selectedLanguage.name} */}
        {/* <div className="arrow">
          {isDropdownOpen ? <FaAngleUp /> : <FaAngleDown />}
        </div> */}
      </button>

      {isDropdownOpen && (
        <ul className="lang-menu">
          {languages.map((lang) => (
            <li
              key={lang.code}
              className={lang.code === selectedLanguage.code ? "active" : ""}
              onClick={() => handleChangeLanguage(lang.code)}
            >
              {/*Language flags show only on production and hide from stage*/}
              {flagEnabled("ENHANCE_LANGUAGE_FLAG") && (
                <>
                  <img
                    src={lang.flag}
                    alt={lang.name}
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      marginRight: "0.5rem",
                    }}
                  />{" "}
                </>
              )}
              {lang.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
